<template>
  <div class="screen-container panel-components">
    <div class="text-center item-carousel">
      <div class="logo-icon">
        <img :src="LogoIcon7" alt="" />
      </div>
      <h3 class="mt-6">Project Calibration</h3>
      <p class="max-w-357 mx-auto">
        You can calibrate your search to train Hirefly’s AI to find more
        suitable candidates. Flip on the switch and review the candidates
        presented to you.
        <br /><br />
        Hirefly will learn from your approval and rejection patterns to improve
        your candidate quality. Flip off the switch to return to your main
        dashboard.
      </p>
      <div class="start-btn mt-10">
        <v-btn elevation="0" height="40" @click="calibrateHandler"
          >Let’s Calibrate</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
import LogoIcon7 from '@/assets/img/speedometer-svgrepo-com.svg';

export default {
  name: 'CalibrationEmptyState',
  data() {
    return {
      LogoIcon7,
    };
  },

  methods: {
    calibrateHandler() {
      this.$emit('calibrate');
    },
  },
};
</script>
